/**Attaches server url to provided string
 * @param link should be without "/" at the beginning
 */
export const getLinkToServerElement = (link, path) => {
  return `${process.env.REACT_APP_HOST}${path ? path + "/" : ""}${link}`;
};
